export default __webpack_public_path__ + "locales/de/ChangePasswordDialog.json?hash=84d6895f39900334125b1a4a57779195";